import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4a2cfcf2&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_1f9b6d6a8c5e3033a639476f0cf6d876/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports